export default __webpack_public_path__ + "static/media/img_company_header5.94ecfd33.png";